import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Scrollbar = forwardRef((props, ref) => {
  const { children, sx, ...other } = props;
  const theme = useTheme();
  const scrollbarStyle = {
    overflow: 'auto',
    position: 'relative',
    '& ::-webkit-scrollbar': { WebkitAppearance: 'none', height: '16px', width: '10px' },
    '&::-webkit-scrollbar': { WebkitAppearance: 'none', height: '16px', width: '10px' },
    '& ::-webkit-scrollbar-thumb': { backgroundColor: theme.palette.action.active, borderRadius: '6px' },
    '&::-webkit-scrollbar-thumb': { backgroundColor: theme.palette.action.active, borderRadius: '6px' },
    '& ::-webkit-scrollbar-track': { backgroundColor: 'transparent' },
    '&::-webkit-scrollbar-track': { backgroundColor: 'transparent' },
    '&:hover': {
      '&::-webkit-scrollbar': { height: '14px', width: '14px' },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.action.active,
        border: `0px solid ${theme.palette.background.paper}`,
      },
      '& .ps__rail-y': { backgroundColor: `transparent !important` },
    },
  };
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  if (isMobile) {
    return (
      <Box ref={ref} sx={{ overflowX: 'auto' }}>
        {children}
      </Box>
    );
  }

  return (
    <Box component={PerfectScrollbar} ref={ref} sx={{ ...scrollbarStyle, ...sx }} {...other}>
      {children}
    </Box>
  );
});

Scrollbar.propTypes = { children: PropTypes.node };

export default Scrollbar;
